import { useEffect, useState } from 'react';

// How far past the top of the viewport a group's header must scroll before
// we consider it the "active" group — sized to match the compact bar height.
const COMPACT_BAR_OFFSET = 160;

export default function useActiveGroupIndex(
  groupRefs,
  totalGroups,
  topOffset = COMPACT_BAR_OFFSET
) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (totalGroups === 0) return undefined;

    let pendingFrame = null;

    const findActiveIndex = () => {
      pendingFrame = null;
      let next = 0;
      for (let i = 0; i < totalGroups; i += 1) {
        const element = groupRefs.current[i];
        if (!element) continue;
        if (element.getBoundingClientRect().top - topOffset > 0) break;
        next = i;
      }
      setActiveIndex(prev => (prev === next ? prev : next));
    };

    const scheduleUpdate = () => {
      if (pendingFrame === null) pendingFrame = requestAnimationFrame(findActiveIndex);
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    findActiveIndex();

    return () => {
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      if (pendingFrame !== null) cancelAnimationFrame(pendingFrame);
    };
  }, [totalGroups, groupRefs, topOffset]);

  return activeIndex;
}
